import dance_logo from "../assets/Images/dance_logo.jpg";
import ranchi from "../assets/Images/ranchi.jpg";
import lucknow from "../assets/Images/lucknow.jpg";
import delhi from "../assets/Images/delhi.jpg";
import mumbai from "../assets/Images/mumbai.jpg";
import kolkata from "../assets/Images/kolkata.jpg";
const DanceEventDatabase = [
  {
    cityName: "Ranchi",
    eventName: "JSCA Dance Championship",
    eventImage: ranchi,
    eventDescription: "Dance and rock the world",
    eventDate: "21/05/2022",
    eventPrize: "Rs. 20000 for winner and a free air travel to UAE",
  },
  {
    cityName: "Lucknow",
    eventName: "Tata Dance Championship",
    eventImage: lucknow,
    eventDescription: "Dance and emote",
    eventDate: "24/05/2022",
    eventPrize: "Rs. 40000 for winner and a Rolex Watch ",
  },
  {
    cityName: "Delhi",
    eventName: "DTDC Dance Competition",
    eventImage: delhi,
    eventDescription: "Dance to Shine",
    eventDate: "01/06/2022",
    eventPrize: "Rs. 1L for winner and a free air travel to Las Vegas",
  },
  {
    cityName: "Mumbai",
    eventName: "Little Masters Dance Championship",
    eventImage: mumbai,
    eventDescription: "Anybody can dance",
    eventDate: "05/06/2022",
    eventPrize: "Rs. 2.5L for winner and free entry to Carnival Dance Troupe",
  },
  {
    cityName: "Chennai",
    eventName: "Glitz Lighting Dance Battle",
    eventImage: dance_logo,
    eventDescription: "Dance to Express",
    eventDate: "15/06/2022",
    eventPrize: "Rs. 1.2L for winner and air ticket to Moscow",
  },
  {
    cityName: "Kolkata",
    eventName: "Splits Dance Masters",
    eventImage: kolkata,
    eventDescription: "Start, Repeat and Dance",
    eventDate: "30/06/2022",
    eventPrize: "Rs. 3L for winner and free entry to Salt Lake",
  },
];
export default DanceEventDatabase;
